import { Controller } from "@hotwired/stimulus";

// Drives the redesigned shop edit form: a left rail switches which section panel
// is visible (all panels stay in the DOM, so every field still submits), and
// editing any field reveals an "unsaved changes" indicator and enables Save.
// On a fresh load (incl. after a successful save → redirect back to edit) the
// form is pristine: Save is disabled and the indicator hidden.
export default class extends Controller {
  static targets = ["tab", "panel", "indicator", "save"];

  connect() {
    this.markDirty = this.markDirty.bind(this);
    // Allow deep-linking to a section via the URL hash (e.g. .../edit#variants),
    // falling back to the first tab.
    const fromHash = window.location.hash && window.location.hash.slice(1);
    const initial =
      fromHash && this.tabTargets.some((t) => t.dataset.section === fromHash)
        ? fromHash
        : this.tabTargets[0] && this.tabTargets[0].dataset.section;
    this.show(initial);
    this.element.addEventListener("input", this.markDirty);
    this.element.addEventListener("change", this.markDirty);
  }

  disconnect() {
    this.element.removeEventListener("input", this.markDirty);
    this.element.removeEventListener("change", this.markDirty);
  }

  select(event) {
    event.preventDefault();
    const section = event.currentTarget.dataset.section;
    this.show(section);
    // Make each section addressable: keep the URL hash in sync (e.g. #widget_validator)
    // without adding history entries or triggering a scroll/hashchange.
    if (section && window.history && window.history.replaceState) {
      window.history.replaceState(null, "", `#${section}`);
    }
  }

  show(section) {
    if (!section) return;
    this.panelTargets.forEach((p) => {
      p.hidden = p.dataset.section !== section;
    });
    this.tabTargets.forEach((t) => {
      const active = t.dataset.section === section;
      t.style.background = active ? "#FAECE7" : "transparent";
      t.style.color = active ? "#712B13" : "";
      t.style.fontWeight = active ? "500" : "400";
    });
  }

  markDirty(event) {
    const target = event && event.target;
    // Ignore controls that aren't form fields (e.g. the preview component selector
    // has no name and shouldn't count as an edit).
    if (!target || !target.name) return;
    if (this.hasIndicatorTarget) this.indicatorTarget.hidden = false;
    if (this.hasSaveTarget) this.saveTarget.disabled = false;
  }
}
